import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';
import { motion } from 'framer-motion';
export const FloatingActions = () => {
  return <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-4" data-id="element-41">
      <motion.a href="tel:+17813090991" whileHover={{
      scale: 1.1
    }} whileTap={{
      scale: 0.9
    }} className="w-14 h-14 bg-pink-primary text-white rounded-full flex items-center justify-center shadow-lg shadow-pink-primary/30 hover:bg-pink-hover transition-colors" aria-label="Call Now" data-id="element-42">
        <Phone className="w-6 h-6" data-id="element-43" />
      </motion.a>

      <motion.a href="https://wa.me/17813090991" target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.1
    }} whileTap={{
      scale: 0.9
    }} className="w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-lg shadow-[#25D366]/30 hover:bg-[#20BA56] transition-colors relative" aria-label="WhatsApp" data-id="element-44">
        <span className="absolute inset-0 rounded-full border-2 border-[#25D366] animate-ping opacity-20" data-id="element-45"></span>
        <MessageCircle className="w-7 h-7" data-id="element-46" />
      </motion.a>
    </div>;
};